<template>
	<div
		data-component="menu-component"
		id="menu-page-container"
	>
		<div data-element="search-input-mobile">
			<search-input
				:searchQuery="searchQuery"
				:updateSearchQuery="updateSearchQuery"
				:closeSearch="closeSearch"
			/>
		</div>
		<dynamic-link
			v-font-style="this.$store.getters['ui/getBodyCopyFontDetail']('normal')"
			data-element="dietary-requirements-link-mobile"
			text="Dietary Requirements"
			size="xs"
			:link="true"
			:href="allergensLink"
			:left="true"
			:external="true"
		/>
			<div data-element="menu-container">
				<ul data-element="menu" v-if="loaded && (searchQuery.length < 2)" id="menu-component">
                    <template v-for="(group, groupIndex) in menu.display.displayGroups">
                        <menu-group
                            v-if="!isHidden(group.groupName)"
                            :id="setId(group.groupName)"
                            :key="groupIndex"
                            :items="group.items"
                            :groupName="group.groupName"
                            :getProduct="getProduct"
                            :getCG="getCG"
                            :getKeyWord="getKeyWord"
                            :addItemToBasket="addItemToBasket"
                            :removeItemFromBasket="removeItemFromBasket"
                            :getItemCount="getItemCount"
                            :cgIndex="cgIndex"
                            :isVeg="isVeg"
                            :isVegan="isVegan"
                            :getMatchingBasketItemsChoicesAndPortions="getMatchingBasketItemsChoicesAndPortions"
                            :menuLabel="menuLabel"
                        />
                    </template>
				</ul>
				<ul data-element="menu" v-else>
					<transition-group v-if="filteredMenu.length" name="fade">
						<product
							v-for="(item, itemIndex) in filteredMenu"
							:key="itemIndex + 1"
							:product="item.product"
							:getProduct="getProduct"
							:getCG="getCG"
							:cgIndex="cgIndex"
							:getKeyWord="getKeyWord"
							:addItemToBasket="addItemToBasket"
							:getItemCount="getItemCount"
							:removeItemFromBasket="removeItemFromBasket"
							:isVeg="isVeg"
							:isVegan="isVegan"
							:getMatchingBasketItemsChoicesAndPortions="getMatchingBasketItemsChoicesAndPortions"
						/>
					</transition-group>
					<li
						v-font-style="this.$store.getters['ui/getBodyCopyFontDetail']('normal')"
						data-element="no-result-message"
						v-else
					>
						Oops, no products found, please try again.
					</li>
				</ul>
			</div>
	</div>
</template>

<script>

	import DynamicLink    from '@/components/ui/DynamicLink';
	import MenuGroup      from '@/components/menu/MenuGroup';
	import SearchInput    from '@/components/menu/SearchInput';
	import Product        from '@/components/menu/Product';
	import menuAndBasket  from '@/mixins/menuAndBasket';

	export default {
		components: {
			DynamicLink,
			MenuGroup,
			SearchInput,
			Product
		},
		mixins: [
			menuAndBasket
		],
		data () {
			return {
				searchQuery: ''
			}
		},
		props: [
			'loaded',
			'menu',
			'menuLabel',
			'addItemToBasket',
			'removeItemFromBasket',
			'getMatchingBasketItemsChoicesAndPortions',
			'basketLink',
			'handleCheckoutBtnClick',
			'loading',
			'emptyText'
		],
		computed: {
			allergensLink () {
				return this.$store.getters['getSite'] && this.$store.getters['getSite'].allergensLink;
			},
			flattenedMenu () {
				const flattenedArray = [];
				this.menu && this.menu.display && this.menu.display.displayGroups.forEach(group => {
					if (group.groupName !== 'Upsell') {
						group.items.forEach(item => {
							if (item.itemType === 'product') {
								flattenedArray.push(item);
							}
						});
					}
				});
				return flattenedArray;
			},
			filteredMenu () {
				return this.flattenedMenu.reduce((arr, item) => {
					if (arr.length >= 20) return arr;
					if ( item.product.displayName.toLowerCase().includes(this.searchQuery.toLowerCase()) ) {
						arr.push(item);
					};
					return arr;
				}, []);
			},
			reverseLines () {
				return this.basket.lines.slice().reverse();
			}
		},
		methods: {
			isVeg (productId) {
				return this.getProduct(productId).displayRecords &&
							 this.getProduct(productId).displayRecords[0].keywords &&
							 this.getProduct(productId).displayRecords[0].keywords.includes(301);
			},
			isVegan (productId) {
				return this.getProduct(productId).displayRecords &&
							 this.getProduct(productId).displayRecords[0].keywords &&
							 this.getProduct(productId).displayRecords[0].keywords.includes(302);
			},
			getHref (groupName) {
				const id = this.setId(groupName);
				return `#${id}`;
			},
			setId (groupName) {
				const id = groupName.toLowerCase().split(' ').join('-');
				return id;
			},
			isHidden (name) {
				return name === 'Upsell';
			},
			updateSearchQuery (query) {
				this.searchQuery = query;
			},
			closeSearch () {
				this.searchQuery = '';
			}
		}
	}
</script>

<style lang="scss" scoped>

	@import '@/assets/scss/variables.scss';
	@import '@/assets/scss/helpers.scss';

	[data-component='menu-component'] {
		margin:0 auto;
		display:flex;
		flex-direction:column;
		width:100%;
		max-width:456px;
		@include whenScreenIs(md) {
			max-width:none;
			flex-direction:row;
			padding-top:42px;
		}
		[data-element='no-result-message']{
			text-align: center;
			margin-top: 10px;
		}
		[data-element='menu-nav-container'] {
			height:auto;
			padding:0 16px;
			display:none;
			@include whenScreenIs(md) {
				padding:0;
				margin-left:12px;
				width:160px;
				height:800px;
				display:block;
			}
			[data-element='menu-nav'] {
				@include whenScreenIs(md) {
					width:152px;
				}
				[data-element='outer-container'] {
					@include whenScreenIs(md) {
						height:80vh;
						width:152px;
						position:relative;
						overflow:hidden;
					}
					[data-element='scrollable-container'] {
						@include whenScreenIs(md) {
							position:absolute;
							left:0;
							-ms-overflow-style:none;
							scrollbar-width:none;
							overflow-y:auto;
							overflow-x:hidden;
							height:80vh;
							width:152px;
							padding-bottom:100px;
							&:-webkit-scrollbar {
								display:none;
							}
						}
						div.scrollactive-nav { overflow:hidden }
						[data-element='menu-categories-container'] {
							display:none;
							@include whenScreenIs(md) {
								display:block;
								width:170px; // to hide scrollbar on Firefox
							}
							[data-element='menu-categories'] {
								display:none;
								@include whenScreenIs(md) {
									display:block;
								}
								[data-element='category'] {
									display:block;
									min-height:40px;
									border-bottom:2px solid $white-two;
									font-size:16px;
									padding:13px 18px 7px 8px;
									&.is-active, &.scrollactive-first {
										font-weight:800;
										text-decoration:none;
									}
								}
							}
						}
						[data-element='dietary-requirements-link'] {
							margin-top:16px;
							margin-bottom:16px;
						}
					}
				}
			}
		}
		[data-element='search-input-mobile'] {
			width:100%;
			height:48px;
			padding:0 16px;
			@include whenScreenIs(md) {
				display:none;
			}
		}
		[data-element='dietary-requirements-link-mobile'] {
			padding:8px 0 12px;
			@include whenScreenIs(md) {
				display:none;
			}
		}
		[data-element='menu-container'] {
			margin:0 16px 64px;
			max-width:456px;
			flex-grow:1;
			@include whenScreenIs(md) {
				margin:0 0px 64px 0px;
				padding:0 38px 0 40px;
			}
			[data-element='menu'] {

				.fade-leave-active, .fade-enter-active {
					transition: opacity .2s;
				}
				.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
					opacity: 0;
				}
			}
		}
		[data-element='basket-container'] {
			display:none;
			width:314px;
			margin-right:12px;
			height:188px;
			@include whenScreenIs(md) {
				display:block;
			}
			[data-element='empty-text'] {
				font-size:14px;
				font-weight:normal;
				padding:16px;
				text-align:center;
			}
		}
	}
</style>
